import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {toInternalPath} from 'utils/notifications/notificationLink';

export const NOTIFICATION_CLICK_MESSAGE = 'notification-click';

// UCSF-3791: firebase-messaging-sw.js does not control the app's pages, so it cannot navigate them itself. On a push
// notification click it focuses an open GritxSite window and posts {type: 'notification-click', link}; the app then
// navigates with its router. Mounted once, inside the router.
export const useNotificationClickNavigation = (): void => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!('serviceWorker' in navigator)) {
      return undefined;
    }

    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type !== NOTIFICATION_CLICK_MESSAGE) {
        return;
      }

      const link = toInternalPath(event.data.link);

      if (link) {
        navigate(link);
      }
    };

    navigator.serviceWorker.addEventListener('message', handleMessage);

    return () => {
      navigator.serviceWorker.removeEventListener('message', handleMessage);
    };
  }, [navigate]);
};
